import gql from 'graphql-tag'

const ScanPassengerTicket = gql`
  mutation ScanPassengerTicket($input: ScanPassengerTicketMutationInput!){
    scanPassengerTicket(input: $input) {
      passengerTicket {
        id
        claimsConnection {
          edges {
            cursor
            node {
              id
              codeClaim
            }
          }
        }
        flightsPassengerTicketsConnection {
          edges {
            cursor
            node {
              id
              status
              flight {
                id
                delayedFlight {
                  id
                  utcActualArrivalDate
                  utcScheduledArrivalDate
                  localScheduledDepartureDate
                  delayAtArrival
                  cancelled
                  airportOrigin {
                    name
                    iata
                  }
                  airportDestination {
                    name
                    iata
                  }
                }
                airportOrigin {
                  name
                  iata
                }
                airportDestination {
                  name
                  iata
                }
                airline {
                  iata
                  name
                }
                number
                localArrivalDate
                localDepartureDate
              }
            }
          }
        }
      }
    }
  }
`

export { ScanPassengerTicket }


// WEBPACK FOOTER //
// ./src/mutations/ScanPassengerTicket.js